import {z} from 'zod';

export const omnichannelSsoResponseSchema = z.object({
    link: z.string(),
});

export type OmnichannelSsoLinkResponseType = z.infer<typeof omnichannelSsoResponseSchema>;
